import {
  deliverablesTableHeader,
  deliverableStatus,
  milestonesTableHeader,
  milestoneStatus,
  tasksTableHeader,
  taskStatus,
} from "../../constants/Project";
import { TDMAnalytics } from "../../types/Analytics";
import { GoalInterface } from "../../types/Project";

export default function goalTotalPercentage(goals: GoalInterface[]) {
  let total = 0;
  goals.forEach((goal) => {
    total += +goal.percentage;
  });

  return total;
}

export function calculateProjectBudgetTotal(
  budgets: { name: string; amount: number }[]
) {
  let total = 0;
  if (budgets) {
    budgets.forEach((budget) => {
      total += +budget.amount;
    });
  }

  return total;
}

export function convertAmountFormatStringToNumber(amountStringFormat: string) {
  return +amountStringFormat.split(",").join("");
}

export function findTaskCategoryCode(category: string) {
  let catCode = "none";
  // Object.keys(taskCategories).forEach((key) => {
  //   if (taskCategories[key] === category) {
  //     catCode = key;
  //   }
  // });

  return catCode;
}

export function getTdmTableHeader(tdm: string) {
  if (tdm === "task") {
    return tasksTableHeader;
  }

  if (tdm === "deliverable") {
    return deliverablesTableHeader;
  }

  if (tdm === "milestone") {
    return milestonesTableHeader;
  }

  return;
}

export function countCompleteStatus(items: TDMAnalytics[]) {
  let completed = 0;

  items.forEach((item) => {
    if (item.status === "COMPLETE") {
      completed = +1;
    }
  });

  return completed;
}

export function countTotalItems(items: TDMAnalytics[]) {
  return items.reduce<number>((acc, item) => {
    acc += item._count.status;
    return acc;
  }, 0);
}

export function countTDMStatus(items: any[], phase?: string) {
  let count: { [key: string]: number } = {};

  items.forEach((item) => {
    count[item.status] = 0;
  });

  if (phase) {
    items.forEach((item) => {
      if (item.phase === phase) {
        count[item.status] += 1;
      }
    });
    return count;
  }

  items.forEach((item) => {
    count[item.status] += 1;
  });

  return count;
}

export function countApprovals(items: TDMAnalytics[]) {
  const tdmUnderReviewStatusCount = countTDMStatus(items)["UNDER_REVIEW"];
  const tdmUnderRevisionStatusCount = countTDMStatus(items)["UNDER_REVISION"];
  let total = tdmUnderReviewStatusCount ? tdmUnderReviewStatusCount : 0;
  total += tdmUnderRevisionStatusCount ? tdmUnderRevisionStatusCount : 0;

  return total;
}

export function tdmStatusDataForPieChart(
  items: any[],
  status: { [key: string]: string },
  phase?: string
) {
  let pieChartData: { data: number; color: string }[] = [];
  const pieColors = ["#0FCA98", "#D9B64E", "#F27141", "#38B2AC", "#DC3545"];
  const labels: string[] = [];
  const phaseActivitiesCount: { [key: string]: number } = {
    acquisition: 0,
    finance: 0,
    procurement: 0,
    development: 0,
    design: 0,
    construction: 0,
  };

  items.forEach((item) => {
    phaseActivitiesCount[item.phase] += 1;
  });

  const count = countTDMStatus(items, phase);

  Object.keys(count).forEach((key, idx) => {
    pieChartData.splice(idx, 0, { data: count[key], color: pieColors[idx] });
    labels.splice(idx, 0, key === "NOT_ASSIGNED" ? "Not Started" : status[key]);
  });

  return { labels, pieChartData, phaseActivitiesCount };
}

export function getTdmStatusList(tdm: string) {
  if (tdm.toLowerCase() === "task" || tdm.toLowerCase() === "tasks") {
    return taskStatus;
  }

  if (
    tdm.toLowerCase() === "deliverable" ||
    tdm.toLowerCase() === "deliverables"
  ) {
    return deliverableStatus;
  }

  if (tdm.toLowerCase() === "milestone" || tdm.toLowerCase() === "milestones") {
    return milestoneStatus;
  }

  return taskStatus;
}

//CCLF Specific
export function getCCLFLoan(budget: { name: string; amount: number }[]) {
  if (budget) {
    const cclfLoan = budget.find((b) => b.name === "CCLF Loan");
    if (cclfLoan) {
      return cclfLoan.amount;
    }
  }
  return 0;
}

export function getCCLFLoanTotal(budget: { name: string; amount: number }[]) {
  if (budget) {
    const cclfLoan = budget?.reduce((acc, next) => acc + next.amount, 0);
    if (cclfLoan) {
      return cclfLoan;
    }
  }
  return 0;
}

export function getCCLFAcquisitionsTotal(
  budget: { name: string; amount: number }[]
) {
  const cclfAcquisition = budget.reduce((acc, next) => {
    if (next.name === "Acquisition") {
      return acc + next.amount;
    }
    return acc + 0;
  }, 0);
  if (cclfAcquisition) {
    return cclfAcquisition;
  }
  return 0;
}

export function constructQueryParamsUrl(
  params:
    | {
        [key: string]: string | number | boolean | undefined;
      }
    | undefined
): string {
  let paramsArray: string[] = [];

  if (params) {
    Object.keys(params).forEach((key: string, idx: number) => {
      if (params[key]) {
        paramsArray.push(`${key}=${params[key]}`);
      }
    });
  }

  let constructedParams = "";

  if (paramsArray.length > 0) {
    constructedParams += "?";
    constructedParams += paramsArray.join("&");
  }

  return constructedParams;
}
